import { Box, SxProps, Theme } from '@mui/material';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
};

const Container = ({ id, sx, children }: Props) => (
  <Box id={id} sx={{ width: '100%', maxWidth: '1000px', mx: 'auto', my: 0, p: 2, ...sx }}>
    {children}
  </Box>
);

export default Container;
